import {Component, OnInit} from '@angular/core';

import packageJson from '../../../../package.json';
import { CopyableDirective } from '../../directives/copyable.directive';


@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    imports: [CopyableDirective]
})
export class VersionComponent implements OnInit {
    version: string = packageJson.version;

    constructor() {
    }

    ngOnInit(): void {
    }

}
